import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import Quill from 'quill';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
})
export class EditorComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() inputName: string;
  @Input() htmlInputName: string;
  editor: any;
  editorOptions = {
    theme: 'vs-dark',
    language: 'html',
  };

  options = {
    contextmenu: true,
    minimap: {
      enabled: true,
    },
  };
  format: string;

  constructor() {
    // configure Quill to use inline styles so the email's format properly
    const DirectionAttribute = Quill.import('attributors/attribute/direction');
    Quill.register(DirectionAttribute, true);

    const AlignClass = Quill.import('attributors/class/align');
    Quill.register(AlignClass, true);

    const BackgroundClass = Quill.import('attributors/class/background');
    Quill.register(BackgroundClass, true);

    const ColorClass = Quill.import('attributors/class/color');
    Quill.register(ColorClass, true);

    const DirectionClass = Quill.import('attributors/class/direction');
    Quill.register(DirectionClass, true);

    const FontClass = Quill.import('attributors/class/font');
    Quill.register(FontClass, true);

    const SizeClass = Quill.import('attributors/class/size');
    Quill.register(SizeClass, true);

    const AlignStyle = Quill.import('attributors/style/align');
    Quill.register(AlignStyle, true);

    const BackgroundStyle = Quill.import('attributors/style/background');
    Quill.register(BackgroundStyle, true);

    const ColorStyle = Quill.import('attributors/style/color');
    Quill.register(ColorStyle, true);

    const DirectionStyle = Quill.import('attributors/style/direction');
    Quill.register(DirectionStyle, true);

    const FontStyle = Quill.import('attributors/style/font');
    Quill.register(FontStyle, true);

    const SizeStyle = Quill.import('attributors/style/size');
    Quill.register(SizeStyle, true);
  }

  ngOnInit(): void {
    this.format = 'text';
  }

  activateRTL(editor: any) {
    this.editor = editor;
    this.editor.format('align', 'right');
    this.editor.format('direction', 'rtl');
  }

  onEditorInit(editor) {
    this.editor = editor;
  }

  toggleHTMLCode(event: MouseEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();

    switch (this.format) {
      case 'html':
        this.format = 'text';
        this.formGroup
          .get(this.inputName)
          .setValue(this.formGroup.get(this.htmlInputName).value);
        break;
      case 'text':
        this.format = 'html';
        this.formGroup
          .get(this.htmlInputName)
          .setValue(this.formGroup.get(this.inputName).value);
        setTimeout(() => {
          this.editor.getAction('editor.action.formatDocument').run();
        }, 500);
        break;
    }
  }
}
